<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: string
  }>(),
  {
    size: "40",
  },
);
</script>

<template>
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 110 110"
  >
    <g>
      <g>
        <path
          fill="#087CF7"
          d="M55.1,110.1C24.7,110.1,0,85.4,0,55.1S24.7,0,55.1,0c30.4,0,55.1,24.7,55.1,55.1S85.4,110.1,55.1,110.1z
                     M55.1,8.8C29.6,8.8,8.8,29.6,8.8,55.1s20.7,46.2,46.2,46.2s46.2-20.7,46.2-46.2S80.6,8.8,55.1,8.8z"
        />
      </g>
      <g>
        <g>
          <path
            fill="#087CF7"
            d="M31.6,68.9l8.8-3.9c1.9,6.4,6.6,11.6,15.4,11.6c5.9,0,11.3-2.3,11.3-8.3c0-5.5-3.4-7.5-9.6-8.7l-7.9-1.7
                        c-9-1.8-14.9-6.7-14.9-16.4c0-9.9,8-16.4,20.9-16.4c10.8,0,19.4,4.4,21.9,13.9l-8.3,4.3c-1.8-6.6-6.6-10.3-14.1-10.3
                        c-6.2,0-10.3,2.9-10.3,7.7c0,4.7,2.6,7.1,8.8,8.4l8.3,1.8c9.4,2,15.6,6.3,15.6,16.4c0,9.8-7.4,17.5-21.9,17.5
                        C42,84.9,33.9,78.2,31.6,68.9z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
